function ActionCardWithIcon(props) {
  return (
    <>
      <div className="actionCardWithIcon">
        <div className="_svg">{props.svg}</div>
        <div className="_textWrapper">
          <div className="_text">{props.text}</div>
          <div className="_description">{props.tooltip}</div>
        </div>
        <div className="_button">{props.button}</div>
      </div>
    </>
  );
}

export default ActionCardWithIcon;
